<template>
  <div>
    <v-toolbar tabs :style="{
      zIndex: 1,
      borderTop: '1px solid',
      borderBottom: '1px solid',
      borderColor: '#ccc',
    }" height="80" card color="#fff">
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div class="header_options">
            <div>
              <div class="mr-3" :style="{
                padding: '8px',
                display: 'inline-block',
                backgroundColor: '#ef565c',
                borderRadius: '0.5rem',
              }">
                <v-icon color='white'>groups</v-icon>
              </div>
              <h1 style="display: inline">Colaboradores</h1>
            </div>
            <div>
              <v-btn flat icon color="primary" :disabled="selected.length <= 0" @click="deleteMultipleCollaborator">
                <v-icon>delete</v-icon>
              </v-btn>
              <v-btn flat icon color="primary" :disabled="validWelcomeMessage.length <= 0" @click="onSendWelcome">
                <v-icon>send</v-icon>
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <template v-slot:extension>
        <v-btn dark absolute bottom left fab color="gradiente" @click="addCollaborator">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
    <div class="tab-container">
      <div class="scrollDesign">
        <v-container fluid grid-list-md text-xs-center style="height: 100%">
          <v-layout row wrap style="height: 100%" class="fit-With">
            <v-flex xs12 style="height: 130%" class="ma-12">
              <div class="border-table border-table-color custom-border">
                <v-layout row align-center container fluid>
                  <v-flex grow class="d-flex justify-space-between">
                    <v-container grid-list-md text-xs-center pa-0 ma-0 fluid>
                      <v-layout row wrap>
                        <v-flex md3 xs>
                          <div class="flex-align_center">
                            <div class="mr-3" :style="{
                              padding: '8px',
                              display: 'inline-block',
                              backgroundColor: '#f08286',
                              borderRadius: '0.5rem',
                            }">
                              <v-icon color='white'>groups</v-icon>
                            </div>
                            <p class="text">Colaboradores</p>
                          </div>
                        </v-flex>
                        <v-flex xs md9>
                          <v-container grid-list-md text-xs-center px-0 py-0>
                            <v-layout row wrap>
                              <v-flex md2 class="box custom_space fix_width_field_1">
                                <v-select :items="roles" outline height="50" class="custom-border-field"
                                  v-model="roleSelected" :dense="$vuetify.breakpoint.xsOnly" full-width
                                  @change="filterByRole">
                                  <template v-slot:label>
                                    <span class="grey--text">Rol</span>
                                  </template>
                                  <template v-slot:selection="{ item, index }">
                                    <span class="grey--text caption">{{
                                      item
                                    }}</span>
                                  </template>
                                </v-select>
                              </v-flex>
                              <v-flex md5 class="box fix_width_field_2">
                                <v-text-field height="50" label="Buscar" outline class="custom-border-field "
                                  @change="customSearch" v-model="search">
                                  <template v-slot:prepend-inner>
                                    <v-icon class="icon_search">search</v-icon>
                                  </template>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4 style="display: flex; justify-content: end">
                                <v-btn color="primary" @click="filterClear" v-show="!isAnyFilterActive">
                                  <v-icon left>close</v-icon>Limpiar filtros
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-container fluid class="table-full">
                  <v-layout row wrap style="height: 130%">
                    <v-flex xs12 style="height: 130%" class="ma-12">
                      <div class="border-table custom-border">
                        <v-data-table :headers="headers" rows-per-page-text="Registros por página" select-all
                          :pagination.sync="pagination" @update:pagination="customPaginator" :loading="isLoadingTable"
                          :items="collaborators" item-key="id" :rows-per-page-items="[25, 50, 100]"
                          :total-items="totalItems" no-results-text="No se encontraron coincidencias" v-model="selected">
                          <template v-slot:headers="props">
                            <tr style="background-color: #dddddd">
                              <th style="width: 78px; max-width: 78px; min-width: 78px;">
                                <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary
                                  @click.stop="toggleAll" color="primary" hide-details></v-checkbox>
                              </th>
                              <th style="width: 78px; max-width: 78px; min-width: 78px;">
                                <span>FOTO</span>
                              </th>
                              <th style="width: 140px; max-width: 140px; min-width: 140px;">
                                <span>NOMBRE</span>
                              </th>
                              <th style="width: 140px; max-width: 140px; min-width: 140px;">
                                <span>APELLIDO</span>
                              </th>
                              <th style="max-width: 240px; min-width: 240px;">
                                <span>CORREO</span>
                              </th>
                              <th style="width: 140px; max-width: 140px; min-width: 140px;">
                                <span>ROL</span>
                              </th>
                              <!-- <th v-for="header in props.headers" :key="header.value"
                                :style="header.value === 'role' ? 'width: 140px; max-width: 140px; min-width: 140px;' : 'max-width: 240px; min-width: 140px;'">
                                {{ header.text }}
                              </th> -->
                              <th style="width: 100%;">
                                <span>ACCIÓN</span>
                              </th>
                            </tr>
                          </template>
                          <template v-slot:items="props">
                            <tr>
                              <td style="width: 78px; max-width: 78px; min-width: 78px;">
                                <v-checkbox :input-value="props.selected" primary color="primary" v-model="props.selected"
                                  hide-details></v-checkbox>
                              </td>
                              <td style="width: 78px; max-width: 78px; min-width: 78px;">
                                <v-avatar size="34px">
                                  <img v-if="props.item.image != null || props.item.image != undefined"
                                    :src="props.item.image" alt="Avatar">
                                  <v-icon size="36px" v-else>account_circle</v-icon>
                                </v-avatar>
                              </td>
                              <td style="width: 140px; max-width: 140px; min-width: 140px;">
                                {{ props.item.firstName }}
                              </td>
                              <td style="width: 140px; max-width: 140px; min-width: 140px;">
                                {{ props.item.lastName }}
                              </td>
                              <td style="max-width: 240px; min-width: 240px; overflow: hidden;">
                                {{ props.item.email }}
                              </td>
                              <td style="width: 140px; max-width: 140px; min-width: 140px;">
                                <!-- {{ props.item.role }} -->
                                Administrador
                              </td>
                              <td style="width: 100%;">
                                <v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn small v-on="on" class="custom-border option_button custom_flat_button">
                                      <v-icon>more_vert</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-card>
                                    <v-list>
                                      <v-list-tile @click="editCollaborator(props.item)">
                                        <v-list-tile-action>
                                          <img :src="
                                            require('@/assets/icons/pencil_alt.svg')
                                          " alt="" height="26px" />
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                          <v-list-tile-title>Editar</v-list-tile-title>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                      <v-divider></v-divider>
                                      <v-list-tile @click="deleteCollaborator(props.item)">
                                        <v-list-tile-action>
                                          <img :src="
                                            require('@/assets/icons/trash.svg')
                                          " alt="" height="27px" />
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                          <v-list-tile-title>Eliminar</v-list-tile-title>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-list>
                                  </v-card>
                                </v-menu>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:pageText="props">
                            {{ props.pageStart }} - {{ props.pageStop }} de
                            {{ props.itemsLength }}
                          </template>
                          <template v-slot:no-data>
                            Sin Resultados
                          </template>
                        </v-data-table>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
    <CollaboratorsModal :collaborator="modal.collaborator" v-model="modal.show"
      :isNewCollaborator="modal.isNewCollaborator" v-on:update="onUpdateCollaborator">
    </CollaboratorsModal>
    <CollaboratorsModalConfirm v-model="modal.showConfirm" v-on:changed="onChangeConfirmModal"
      v-on:update="onUpdateConfirmModal" :content="modal.confirmContent">
    </CollaboratorsModalConfirm>
    <CollaboratorsModalSuccess v-model="modal.showSuccess" :content="modal.successContent">
    </CollaboratorsModalSuccess>
    <CollaboratorsModalLoading v-model="modal.loading">
    </CollaboratorsModalLoading>
    <CollaboratorsModalError v-model="modal.showError" :content="modal.errorContent">
    </CollaboratorsModalError>
  </div>
</template>
<script>
import CollaboratorsModal from "./components/CollaboratorsModal";
import CollaboratorsModalConfirm from "./components/CollaboratorsModalConfirm";
import CollaboratorsModalSuccess from "./components/CollaboratorsModalSuccess";
import CollaboratorsModalError from "./components/CollaboratorsModalError";
import CollaboratorsModalLoading from "./components/CollaboratorsModalLoading";
import { createCollaboratorAdapter, sendCollaboratorIdsAdapter, onResponseDeleteCollaboratorAdapter, CollaboratorListParser, CollaboratorModel, CollaboratorSerializer, editCollaboratorAdapter } from "./fabricModels";
import { actionTypes, createEditCollaboratorErrors, deleteAndWelcomeEmailMessage, posibleIds, buttonsConfirmDelete, deleteMultipleConfirmInfo, deleteSingleConfirmInfo } from "./utils.js";
import { apiController } from "./api/controller";

export default {
  components: {
    CollaboratorsModal,
    CollaboratorsModalConfirm,
    CollaboratorsModalSuccess,
    CollaboratorsModalError,
    CollaboratorsModalLoading
  },
  data: () => {
    return {
      headers: [
        {
          text: 'NOMBRE',
          align: 'left',
          sortable: false,
          value: 'firstName',
        },
        {
          text: 'APELLIDO',
          align: 'left',
          sortable: false,
          value: 'lastName',
        },
        {
          text: 'CORREO',
          align: 'left',
          sortable: false,
          value: 'email',
        },
        {
          text: 'ROL',
          align: 'left',
          sortable: false,
          value: 'role',
        },
      ],
      collaborators: [],
      roles: [
        'Todos',
        'Administrador',

      ],
      roleSelected: 'Todos',
      selected: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: 'name',
      },
      totalItems: 0,
      isLoadingTable: false,
      search: '',
      modal: {
        title: '',
        collaborator: null,
        isNewCollaborator: false,
        loading: false,
        show: false,
        showConfirm: false,
        showSuccess: false,
        showError: false,
        successContent: null,
        confirmContent: null,
        errorContent: null,
      },
      actionType: null,
    }
  },
  created() {
    this.addOverrideGlobalCss()
  },
  beforeRouteLeave: function (to, from, next) {
    this.removeOverrideGlobalCss(to.name)
    next()
  },
  methods: {
    addOverrideGlobalCss() {
      const style = document.createElement('style')
      style.id = 'tempOverrideGlobalCss'
      style.innerHTML = `
        .v-menu__content {
          border-radius: 0.5rem !important;
          border: 1px solid #ccc;
        }
        :root {
          --main-color: #ef565c;
          --pale-blue: #374151;
          --low-grey: #D1D5DB;
          --mid-grey: #f5f5f5;
          --top-grey: #E5E5E5;
        }
        `
      document.head.appendChild(style)
    },
    removeOverrideGlobalCss(newRoute) {
      if (newRoute != 'Colleges') {
        const sheet = document.getElementById('tempOverrideGlobalCss')
        if (sheet != null) {
          sheet.remove()
        }
      }
    },
    customPaginator() {
      this.getColleges()
    },
    _offsetHandler() {
      if (this.pagination.page == 1) return 0
      return (this.pagination.page - 1) * this.pagination.rowsPerPage + 1
    },
    customSearch() {
      this.getColleges()
    },
    filterByRole() {
      this.getColleges()
    },
    async getColleges({
      offset = this._offsetHandler(),
      size = this.pagination.rowsPerPage,
      search = this.search,
      id_role = posibleIds({ id: this.roleSelected }),
    } = {}) {
      this.isLoadingTable = true
      const { data, error } = await apiController.getCollaborators({
        params: {
          'offset': offset,
          'page': size,
          'search': search,
          'id_role': id_role,
        }
      })
      if (error !== null) {
        this.modal.errorContent = 'Ocurrio un error al cargar los datos'
        this.modal.showError = true;
        this.isLoadingTable = false;
        return
      }

      const parsedCollaborators = CollaboratorListParser(data.data);

      this.collaborators = parsedCollaborators.data
      this.totalItems = parsedCollaborators.total

      this.isLoadingTable = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.collaborators.slice()
    },

    // posible actions
    editCollaborator(collaborator) {
      this.actionType = actionTypes.editCollaborator
      this.modal.show = true;
      this.modal.isNewCollaborator = false;
      this.modal.collaborator = structuredClone(collaborator);
    },
    addCollaborator() {
      this.actionType = actionTypes.createCollaborator
      this.modal.show = true;
      this.modal.isNewCollaborator = true;
      const tempCollaborator = {
        firstName: "",
        lastName: "",
        email: "",
      }
      this.modal.collaborator = createCollaboratorAdapter(tempCollaborator).mutable;
    },
    deleteCollaborator(collaborator) {
      this.modal.isNewCollaborator = false;
      this.actionType = actionTypes.deleteCollaborator
      this.modal.confirmContent = {
        ...buttonsConfirmDelete,
        ...deleteSingleConfirmInfo,
        isNew: this.modal.isNewCollaborator,
      };
      this.modal.collaborator = structuredClone(collaborator);
      this.modal.successContent = '¡Colaborador eliminado con éxito!';
      this.modal.showConfirm = true;
    },
    deleteMultipleCollaborator() {
      this.modal.isNewCollaborator = false;
      this.actionType = actionTypes.deleteMultipleCollaborator
      const confirmInfo = this.selected.length === 1 ?
        deleteSingleConfirmInfo
        : deleteMultipleConfirmInfo;

      this.modal.confirmContent = {
        ...buttonsConfirmDelete,
        ...confirmInfo,
        isNew: this.modal.isNewCollaborator,
      };
      this.modal.successContent = '¡Colaborador eliminado con éxito!';
      this.modal.showConfirm = true;
    },

    async onSendWelcome() {
      const pickIds = this._filterAvailableSendWelcomeEmail().map((el) => el.id);
      const ids = sendCollaboratorIdsAdapter(pickIds)

      if (ids === null) return

      this.modal.loading = true;

      const { data } = await apiController.sendWelcomeEmailToCollaborators(ids)
      const parsedResponse = onResponseDeleteCollaboratorAdapter(data.data)
      this.resetSelected()

      if (parsedResponse.success === 0) {
        this.modal.errorContent = deleteAndWelcomeEmailMessage({ title: "Correos enviados", data: parsedResponse });
        this.modal.showError = true;
        this.modal.loading = false;
        return
      }

      this.modal.loading = false;
      this.modal.successContent = deleteAndWelcomeEmailMessage({ title: "Correos enviados", data: parsedResponse });
      this.modal.showSuccess = true;
    },
    // this method handle edit and crete collaborator action with dispatch api events
    async onUpdateCollaborator(event) {
      if (event.isNewCollaborator && this.actionType === actionTypes.createCollaborator) {
        const createEditCollaboratorAdapted = event.collaborator.immutable
        this.modal.loading = true;
        const { error } = await apiController.createCollaborator(createEditCollaboratorAdapted)

        if (error !== null) {
          const errorMsg = createEditCollaboratorErrors(error.response.status)
          this.modal.errorContent = errorMsg
          this.modal.loading = false;
          this.modal.showError = true;
          return
        }

        this.modal.successContent = '¡Colaborador creado con exito!';
        this.modal.loading = false;
        this.modal.showSuccess = true;
        await this.getColleges()
        return;
      }

      this.modal.loading = true;
      const { error } = await apiController.editCollaborator(this.modal.collaborator.id, event.collaborator.immutable)

      if (error !== null) {
        const errorMsg = createEditCollaboratorErrors(error.response.status)
        this.modal.errorContent = errorMsg
        this.modal.loading = false;
        this.modal.showError = true;
        return
      }

      this.modal.successContent = '¡Los datos se han actualizado exitosamente!';
      this.modal.loading = false;
      this.modal.showSuccess = true;
      await this.getColleges()
    },

    // this method handle delete collaborator actions with dispatch api events
    async onUpdateConfirmModal({ showSuccess, isOk }) {
      if (!isOk) return

      if (this.actionType === actionTypes.deleteCollaborator) {
        const message = 'Colaborador eliminado';

        const ids = sendCollaboratorIdsAdapter([this.modal.collaborator.id])
        if (ids === null) return

        this.modal.loading = true;
        const { data } = await apiController.deleteCollaborator(ids)
        const parsedResponse = onResponseDeleteCollaboratorAdapter(data.data)

        if (parsedResponse.success === 0) {
          this.modal.errorContent = deleteAndWelcomeEmailMessage({ title: message, data: parsedResponse });
          this.modal.showError = true;
          this.modal.loading = false;
          await this.getColleges()
          return
        }

        this.modal.loading = false;
        this.modal.successContent = deleteAndWelcomeEmailMessage({ title: message, data: parsedResponse });
        this.modal.showSuccess = true;
        await this.getColleges()
      }

      if (this.actionType === actionTypes.deleteMultipleCollaborator) {
        const message = 'Colaboradores eliminados';

        const pickIds = this.selected.map((el) => el.id);
        const ids = sendCollaboratorIdsAdapter(pickIds)
        if (ids === null) return

        this.modal.loading = true;
        const { data } = await apiController.deleteCollaborator(ids)
        const parsedResponse = onResponseDeleteCollaboratorAdapter(data.data)
        this.resetSelected()

        if (parsedResponse.success === 0) {
          this.modal.errorContent = deleteAndWelcomeEmailMessage({ title: message, data: parsedResponse });
          this.modal.showError = true;
          this.modal.loading = false;
          await this.getColleges()
          return
        }

        this.modal.loading = false;
        this.modal.successContent = deleteAndWelcomeEmailMessage({ title: message, data: parsedResponse });
        this.modal.showSuccess = true;
        await this.getColleges()
      }

    },
    onChangeConfirmModal(event) {
      this.modal.showConfirm = event;
    },
    resetSelected() {
      this.selected = []
    },
    _filterAvailableSendWelcomeEmail() {
      return this.selected.filter((el) => el.canSendEmail === true);
    },
    filterClear() {
      this.search = ""
      this.roleSelected = "Todos"
      this.getColleges();

    }
  },
  computed: {
    validWelcomeMessage: function () {
      return this._filterAvailableSendWelcomeEmail()
    },
    isAnyFilterActive() {
      return !this.search && this.roleSelected === "Todos"
    }
  },
}
</script>
<style scoped>
/* header */
.header_options {
  display: flex;
  justify-content: space-between;
}

/* table */
.icon_search {
  height: 20px;
}

.tab-container {
  background-color: var(--top-grey);
}

.border-table-color {
  background-color: white;
}

.border-table {
  border: 1px solid;
  border-color: var(--low-grey);
  overflow: hidden;
  width: 100%;
}

.option_button {
  background-color: white !important;
  color: var(--low-grey) !important;
  border: 1px solid var(--low-grey);
  min-width: 0px;
  max-width: 35px;
  min-height: 35px;
  padding-left: 10px;
}

.custom_flat_button {
  box-shadow: none !important;
}

.option_button:hover,
.option_button:focus {
  border-color: var(--main-color);
  color: transparent;
}

.option_button:hover i,
.option_button:focus i {
  color: var(--main-color);
}

.text {
  font-weight: bold;
  font-size: 1.1rem;
}

@media (max-width: 960px) {
  .scrollDesign {
    height: 130vh;
  }
}

@media (max-width: 853px) {
  .scrollDesign {
    height: 200vh;
  }
}

@media (max-width: 594px) {
  .scrollDesign {
    height: 400vh;
  }
}

@media (min-width: 960px) {
  .scrollDesign {
    height: 100vh;
  }

  .box {
    height: 50px;
  }
}

/* prevent overflow container */
.fit-With {
  margin-right: auto !important;
  margin-left: auto !important;
}

/* generic */
@media (min-width: 640px) {
  .fix_width_field_1 {
    max-width: 100px;
  }

  .fix_width_field_2 {
    max-width: 250px;
  }

  .custom_space {
    margin-right: 20px;
  }
}

.flex-align_center {
  display: flex;
  align-items: center;
}

.custom-border {
  border-radius: 0.5rem;
}

/* override existing global css */
::v-deep thead tr {
  background-color: #f9fafb !important;
}

::v-deep thead tr th {
  color: #6b7280 !important;
}

::v-deep .custom-border-field .v-input__control .v-input__slot {
  border: 1px solid #dddddd !important;
}
</style>
